var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProdPt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 61,
    viewBox: "0 0 70 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(-570 -443)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 70,
    height: 61,
    rx: 24,
    transform: "translate(570 443)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("text", {
    id: "PT",
    transform: "translate(605 485)",
    fill: "#ffc164",
    fontSize: 32,
    fontFamily: "MyriadPro-Bold, Myriad Pro",
    fontWeight: 700,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -18.864,
    y: 0
  }, "PT")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdPt);
export default __webpack_public_path__ + "static/media/prodPT.5aac680bc7c9ba82ec719bb3fd2476a6.svg";
export { ForwardRef as ReactComponent };